<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
}
</script>
<style>
@media (min-width: 768px){
    #app{
        width: 400px;
        margin: 0 auto;
    }
}
</style>
